import fileSaver from 'file-saver';
import moment from 'moment';
import Type from './BomLibrary.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as BomLibraryService from '../../../../services/bom-library.service';
import * as BomLibraryGroupService from '../../../../services/bom-library-group.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const fetchBomLibraryListData = (params) => async () => {
  try {
    const res = await BomLibraryService.getBomLibraryListNames(params);
    if (res?.code === 200) {
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibraryList = (params) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibrary(params);
    if (res?.code === 200) {
      if (res?.data) {
        await dispatch({
          type: Type.GET_BOM_LIBARARY,
          payload: { doc: res?.data },
        });
      }
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetcategories = (params) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getCategoryList(params);
    if (res?.code === 200) {
      if (params.categoryType === 1) {
        await dispatch({
          type: Type.FETCH_CATEGORY1,
          payload: res.data,
        });
      } else if (params.categoryType === 2) {
        await dispatch({
          type: Type.FETCH_CATEGORY2,
          payload: res.data,
        });
      } else if (params.categoryType === 3) {
        await dispatch({
          type: Type.FETCH_CATEGORY3,
          payload: res.data,
        });
      } else {
        await dispatch({
          type: Type.FETCH_CATEGORY4,
          payload: res.data,
        });
      }
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchUserList = (params) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getUsers(params);
    if (res?.code === 200) {
      await dispatch({
        type: Type.FETCH_USERS,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibraryById = (bomLibId) => async () => {
  try {
    const res = await BomLibraryService.getBomLibraryById(bomLibId);
    if (res?.code === 200) {
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomReferenceType = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryReferenceType(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: Type.FETCH_REFERENCE_TYPE,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomReferenceSupplier = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryReferenceSupplier(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: Type.FETCH_REFERENCE_SUPPLIER,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibarayComposition = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryComposition(data);
    if (res?.code === 200 && res.data) {
      // console.log("fetchBomReferenceSupplier", res.data)
      return await dispatch({
        type: Type.FETCH_COMPOSITION,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibarayUnitOfMeasure = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryUnitOfMeasure(data);
    if (res?.code === 200 && res.data) {
      // console.log("fetchBomUnitOfMeasure", res)
      return await dispatch({
        type: Type.FETCH_UNIT_OF_MEASURE,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

// Bom Library Group Action

export const fetchBomLibraryGroupList = (params) => async () => {
  try {
    const res = await BomLibraryGroupService.getBomLibraryGroup(params);
    if (res?.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchSeason = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryGroupService.getSeasons(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({ type: Type.FETCH_SEASON, payload: res.data });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibraryGroupByDetailId = (params) => async () => {
  try {
    const res = await BomLibraryGroupService.getBomLibraryGroupById(params);
    if (res?.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addBomLibraryGroup = (obj, transactionMsg) => async () => {
  try {
    const res = await BomLibraryGroupService.addNewBomLibraryGroup(obj);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_LIBRARY_GROUP_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const editBomLibraryGroup = (obj, transactionMsg) => async () => {
  try {
    const res = await BomLibraryGroupService.updateBomLibraryGroup(obj);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_LIBRARY_GROUP_VIEW.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const AddBomBomLibaray = (data, transactionMsg) => async () => {
  try {
    const res = await BomLibraryService.addBomLibrary(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

const dataDocs = async (obj, dispatch, res) => {
  if (obj?.hasOwnProperty('searchText') || obj?.searchBomTags) {
    if (obj?.searchText?.length || obj?.searchBomTags?.length) {
      return dispatch({
        type: Type.SEARCH_BOM_LIBARARY,
        payload: { index: obj.pageIndex, data: res.data },
      });
    }
    return dispatch({
      type: Type.ADD_BOM_LIBARARY,
      payload: res.data,
    });
  }
  if (obj?.sortPropertyName?.length) {
    const sortData = {
      ...res.data,
      sortOrder: obj.sortOrder,
      pageIndex: obj.pageIndex,
    };
    return dispatch({
      type: Type.GET_BOM_LIBARARY_WITH_SORT,
      payload: sortData,
    });
  }
  if (obj?.isNewAdded) {
    return dispatch({
      type: Type.ADD_BOM_LIBARARY,
      payload: res.data,
    });
  }
  if (obj?.isOldEdit) {
    return dispatch({
      type: Type.EDIT_BOM_LIBARARY,
      payload: res.data,
    });
  }
  return dispatch({
    type: Type.GET_BOM_LIBARARY,
    payload: res.data,
  });
};

export const getBomLibraryGroup = (obj, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomLibraryService.fetchBomLibrary(obj);
    if (res?.code === 200 && res.data && res.data.doc) {
      dataDocs(obj, dispatch, res);
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteBomLibraryGroupByIdAction = (params, transactionMsg) => async () => {
  try {
    const res = await BomLibraryGroupService.deleteBomLibraryGroup(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_GROUP_VIEW.BACKEND_SERVICE.${res.message}`);

      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteBomBomLibaray = (ids, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomLibraryService.removeBomLibrary(ids);
    if (res?.code === 200) {
      await dispatch({ type: Type.DELETE_BOM_LIBARAY, payload: ids });
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.BACKEND_CONTROLLER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
      return false;
    }
    toasterMsg(transactionMsg(res.message), 'danger');
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const EditBomLibaray = (data, id, transactionMsg) => async () => {
  try {
    const res = await BomLibraryService.editBomLibrary(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.BACKEND_CONTROLLER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else toasterMsg(transactionMsg(res.message), 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveBomSubTypesAction = (data, transactionMsg) => async () => {
  try {
    const res = await BomLibraryService.saveBomSubTypes(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_LIBRARY_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else toasterMsg(res.message, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const emptyLibList = () => async (dispatch) => {
  await dispatch({ type: Type.BOM_LIBARARY_EMPTY });
};

export const saveSequence = (id, data, t) => async () => {
  try {
    const res = await BomLibraryGroupService.saveSequence(id, data);
    if (res?.code === 200) {
      toasterMsg(t(`BOM_TYPE_GROUP_VIEW.${res.message}`), 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchColourWayDocs = (params) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getColourDocs(params);
    if (res?.code === 200) {
      return await dispatch({
        type: Type.FETCH_COLOUR_DOC,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearColourDocs = () => async (dispatch) => {
  try {
    return await dispatch({
      type: Type.FETCH_COLOUR_DOC,
      payload: [],
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addBomLibraryTagsAction = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.addBomLibraryTag(data);
    if (res?.code === 200) {
      await dispatch({
        type: Type.ADD_BOM_LIBARARY_TAGS,
        payload: res.data,
      });
      toasterMsg('Tags added to BOM successfully.', 'success');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibraryTagsAction = () => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryTag();
    if (res?.code === 200) {
      await dispatch({ type: Type.GET_BOM_LIBARARY_TAGS, payload: res.data });
    } else if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibraryTagsById = (bomComponentId) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryTagById(bomComponentId);
    if (res?.code === 200) {
      await dispatch({
        type: Type.GET_BOM_LIBARARYBYID_TAGS,
        payload: res.data.tags,
      });
    } else if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchSuppliersFactories = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.fetchSuppliersFactoriesService(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: Type.FETCH_SUPPLIER_FACTORIES,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearLibraryList = () => async (dispatch) => {
  try {
    await dispatch({
      type: Type.CLEAR_DATA,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const downloadBomLibrary = (data, t) => async () => {
  try {
    const res = await BomLibraryService.exportExcelService(data);
    if (res) {
      fileSaver.saveAs(res, `BOM Library - ${moment().format('DD-MM-YYYY')}`);
    } else if (res?.data?.errMsg) {
      toasterMsg(t(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const uploadBOMXlsxFile = (payload, trans) => async () => {
  try {
    const res = await BomLibraryService.uploadBOMXlsxFileService(payload);
    if (res?.code === 200 && res.data && !res?.data?.success) {
      toasterMsg(trans(`BOM_LIBRARY_VIEW.${res.message}`), 'success');
    } else if (res?.code === 200 && res.data && res?.data?.success) {
      toasterMsg(trans(`BOM_LIBRARY_VIEW.${res.message}`), 'danger');
    } else {
      toasterMsg(trans(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const saveComponentSubTypesAction = (data, transactionMsg) => async () => {
  try {
    const res = await BomLibraryService.saveComponentSubTypes(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`MASTERS.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    } else toasterMsg(res.message, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomComponentSubType = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomComponentSubType(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: Type.FETCH_BOM_SUB_COMPONENT_TYPE,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomComponentSubTypeFromBomList = (data) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomComponentSubType(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: Type.FETCH_BOM_SUB_LIST_COMPONENT_TYPE,
        payload: res.data,
      });
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getBOMOptions = (params) => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBOMOptions(params); // API
    if (res?.code === 200) {
      await dispatch({
        type: Type.GET_ALL_BOM_OPTIONS,
        payload: res.data,
      });
    }
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomLibraryGroupOptions = (params) => async () => {
  try {
    const res = await BomLibraryGroupService.getBomLibraryGroupOptions(params);
    if (res?.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const bulkUpdateProductBomCosting = (payload, trans) => async (dispatch) => {
  try {
    const res = await BomLibraryService.bulkUpdateProductBomCosting(payload);
    if (res?.code === 200) {
      toasterMsg(trans(res?.message) || 'Bulk update completed successfully', 'success');
      return res;
    } 
      toasterMsg(res?.data?.message || ERROR_MESSAGE, 'danger');
      return res;
    
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    throw err;
  }
};
